// "use client";
// import React, { useState, useEffect, useRef } from "react";
// import {
//   Box,
//   Container,
//   Typography,
//   TextField,
//   Button,
//   Grid,
//   Snackbar,
//   Alert,
// } from "@mui/material";
// import Image from "next/image";
// import "../app/globals.css";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// import { useRouter } from "next/navigation";
// import GoogleCaptchaWrapper from "./GoogleCaptchaWrapper";
// import LockIcon from "@mui/icons-material/Lock";
// import { IMAGES } from "../constants/images";
// import { useTranslation } from "react-i18next";

// const FLAG_EN =
//   "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/FlagOne.webp";
// const FLAG_AR =
//   "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/FlagArabic.webp";

// const LANG_OPTIONS = [
//   { value: "en", label: "English", flag: FLAG_EN },
//   { value: "ar", label: "العربية", flag: FLAG_AR },
// ];
// // ── Custom Language Dropdown (white variant for dark bg) ────
// const LangDropdownDark = ({ currentLang, onChange }) => {
//   const [open, setOpen] = useState(false);
//   const ref = useRef(null);
//   const selected =
//     LANG_OPTIONS.find((o) => o.value === currentLang) || LANG_OPTIONS[0];

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (ref.current && !ref.current.contains(e.target)) setOpen(false);
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   return (
//     <Box ref={ref} sx={{ position: "relative", zIndex: 1300, flexShrink: 0 }}>
//       {/* Trigger */}
//       <Box
//         onClick={() => setOpen((prev) => !prev)}
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           gap: "6px",
//           height: "34px",
//           padding: "0 10px",
//           borderRadius: "8px",
//           border: "1.5px solid",
//           borderColor: open ? "#fff" : "rgba(255,255,255,0.4)",
//           backgroundColor: open
//             ? "rgba(255,255,255,0.15)"
//             : "rgba(255,255,255,0.08)",
//           cursor: "pointer",
//           userSelect: "none",
//           minWidth: "130px",
//           maxWidth: "150px",
//           transition: "all 0.2s ease",
//           "&:hover": {
//             borderColor: "#fff",
//             backgroundColor: "rgba(255,255,255,0.15)",
//           },
//         }}
//       >
//         <Box
//           sx={{
//             flex: 1,
//             fontSize: { xs: "12px", sm: "13px" },
//             fontWeight: 500,
//             color: "#fff",
//             fontFamily: "var(--font-outfit)",
//             whiteSpace: "nowrap",
//             display: "flex",
//             alignItems: "center",
//             gap: "5px",
//             overflow: "hidden",
//           }}
//         >
//           <Box
//             component="img"
//             src={selected.flag}
//             alt={selected.label}
//             sx={{
//               width: 22,
//               height: 15,
//               borderRadius: "3px",
//               objectFit: "cover",
//               flexShrink: 0,
//             }}
//           />
//           <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
//             {selected.label}
//           </span>
//         </Box>
//         <Box
//           sx={{
//             color: "rgba(255,255,255,0.7)",
//             display: "flex",
//             alignItems: "center",
//             flexShrink: 0,
//           }}
//         >
//           <svg
//             width="11"
//             height="11"
//             viewBox="0 0 24 24"
//             fill="none"
//             stroke="currentColor"
//             strokeWidth="2.5"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             style={{
//               transition: "transform 0.2s ease",
//               transform: open ? "rotate(180deg)" : "rotate(0deg)",
//             }}
//           >
//             <polyline points="6 9 12 15 18 9" />
//           </svg>
//         </Box>
//       </Box>

//       {/* Dropdown */}
//       {open && (
//         <Box
//           sx={{
//             position: "absolute",
//             top: "calc(100% + 8px)",
//             left: 0,
//             right: 0,
//             backgroundColor: "#fff",
//             borderRadius: "10px",
//             border: "1.5px solid #F0F0F0",
//             boxShadow: "0px 12px 32px rgba(0,0,0,0.2)",
//             zIndex: 9999,
//             overflow: "hidden",
//             minWidth: "140px",
//           }}
//         >
//           <Box
//             sx={{ padding: "8px 14px 6px", borderBottom: "1px solid #F5F5F5" }}
//           >
//             {/* <Box
//               sx={{
//                 fontSize: "11px",
//                 fontWeight: 600,
//                 color: "#AAAAAA",
//                 letterSpacing: "0.06em",
//                 textTransform: "uppercase",
//                 fontFamily: "var(--font-outfit)",
//               }}
//             >
//               Language
//             </Box> */}
//           </Box>
//           {LANG_OPTIONS.map((option) => {
//             const isActive = currentLang === option.value;
//             return (
//               <Box
//                 key={option.value}
//                 onClick={() => {
//                   onChange(option.value);
//                   setOpen(false);
//                 }}
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "10px",
//                   padding: "10px 14px",
//                   cursor: "pointer",
//                   backgroundColor: isActive ? "#FFFBF0" : "#fff",
//                   borderLeft: isActive
//                     ? "3px solid #FFB200"
//                     : "3px solid transparent",
//                   transition: "all 0.15s ease",
//                   "&:hover": { backgroundColor: "#FFFBF0" },
//                 }}
//               >
//                 <Box
//                   component="img"
//                   src={option.flag}
//                   alt={option.label}
//                   sx={{
//                     width: 26,
//                     height: 18,
//                     borderRadius: "3px",
//                     objectFit: "cover",
//                     flexShrink: 0,
//                   }}
//                 />
//                 <Box
//                   sx={{
//                     flex: 1,
//                     fontSize: "14px",
//                     fontWeight: isActive ? 600 : 400,
//                     color: isActive ? "#FFB200" : "#333",
//                     fontFamily:
//                       option.value === "ar"
//                         ? "sans-serif"
//                         : "var(--font-outfit)",
//                   }}
//                 >
//                   {option.label}
//                 </Box>
//                 {isActive && (
//                   <Box
//                     sx={{
//                       width: "18px",
//                       height: "18px",
//                       borderRadius: "50%",
//                       backgroundColor: "#FFB200",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       flexShrink: 0,
//                     }}
//                   >
//                     <svg width="10" height="10" viewBox="0 0 12 12" fill="none">
//                       <path
//                         d="M2 6L5 9L10 3"
//                         stroke="white"
//                         strokeWidth="1.8"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       />
//                     </svg>
//                   </Box>
//                 )}
//               </Box>
//             );
//           })}
//         </Box>
//       )}
//     </Box>
//   );
// };

// // ── Main Component ───────────────────────────────────────────
// const FoundingMemberMainSection = () => {
//   const { t, i18n } = useTranslation();
//   const isArabic = i18n.language === "ar";
//   const router = useRouter();
//   const [currentLang, setCurrentLang] = useState(i18n.language || "en");

//   const handleLanguageChange = (newLang) => {
//     setCurrentLang(newLang);
//     i18n.changeLanguage(newLang);
//     document.dir = newLang === "ar" ? "rtl" : "ltr";
//     document.documentElement.lang = newLang;
//   };

//   const [timeLeft, setTimeLeft] = useState({
//     days: 0,
//     hours: 0,
//     minutes: 0,
//     seconds: 0,
//   });
//   const [animating, setAnimating] = useState({
//     days: false,
//     hours: false,
//     minutes: false,
//     seconds: false,
//   });
//   const [prevTime, setPrevTime] = useState({
//     days: 0,
//     hours: 0,
//     minutes: 0,
//     seconds: 0,
//   });
//   const [remainingSpots, setRemainingSpots] = useState(43);
//   const [discountPercentage, setDiscountPercentage] = useState(60);
//   const [formData, setFormData] = useState({
//     fullName: "",
//     businessName: "",
//     businessEmail: "",
//     phoneNumber: "",
//     linkedinProfile: "",
//   });
//   const [errors, setErrors] = useState({
//     fullName: "",
//     businessName: "",
//     businessEmail: "",
//     phoneNumber: "",
//   });
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [submitMessage, setSubmitMessage] = useState({ type: "", text: "" });
//   const [showToast, setShowToast] = useState(false);
//   const [captchaVerified, setCaptchaVerified] = useState(false);
//   const [captchaError, setCaptchaError] = useState("");

//   useEffect(() => {
//     const calculateTimeLeft = () => {
//       try {
//         const offersData = localStorage.getItem("offersData");
//         if (!offersData)
//           return { days: 7, hours: 15, minutes: 30, seconds: 45 };
//         const parsedData = JSON.parse(offersData);
//         const spots = parsedData?.data?.remainingSpots;
//         if (spots !== undefined && spots !== null) setRemainingSpots(spots);
//         const discount = parsedData?.data?.discountPercentage;
//         if (discount !== undefined && discount !== null)
//           setDiscountPercentage(discount);
//         const expiryTime = parsedData?.data?.ExpiryTime;
//         if (!expiryTime || !Array.isArray(expiryTime) || expiryTime.length < 4)
//           return { days: 7, hours: 15, minutes: 30, seconds: 45 };
//         const [targetDays, targetHours, targetMinutes, targetSeconds] =
//           expiryTime;
//         const totalSeconds =
//           targetDays * 86400 +
//           targetHours * 3600 +
//           targetMinutes * 60 +
//           targetSeconds;
//         const now = Math.floor(Date.now() / 1000);
//         const savedTimestamp = parsedData?.data?.timestamp || now;
//         const elapsed = now - savedTimestamp;
//         const remaining = Math.max(0, totalSeconds - elapsed);
//         return {
//           days: Math.floor(remaining / 86400),
//           hours: Math.floor((remaining % 86400) / 3600),
//           minutes: Math.floor((remaining % 3600) / 60),
//           seconds: remaining % 60,
//         };
//       } catch {
//         return { days: 7, hours: 15, minutes: 30, seconds: 45 };
//       }
//     };
//     const initial = calculateTimeLeft();
//     setTimeLeft(initial);
//     setPrevTime(initial);
//     const timer = setInterval(() => {
//       const newTime = calculateTimeLeft();
//       if (
//         newTime.days === 0 &&
//         newTime.hours === 0 &&
//         newTime.minutes === 0 &&
//         newTime.seconds === 0
//       )
//         clearInterval(timer);
//       setTimeLeft(newTime);
//       if (prevTime.days !== newTime.days) {
//         setAnimating((p) => ({ ...p, days: true }));
//         setTimeout(() => setAnimating((p) => ({ ...p, days: false })), 200);
//       }
//       if (prevTime.hours !== newTime.hours) {
//         setAnimating((p) => ({ ...p, hours: true }));
//         setTimeout(() => setAnimating((p) => ({ ...p, hours: false })), 200);
//       }
//       if (prevTime.minutes !== newTime.minutes) {
//         setAnimating((p) => ({ ...p, minutes: true }));
//         setTimeout(() => setAnimating((p) => ({ ...p, minutes: false })), 200);
//       }
//       if (prevTime.seconds !== newTime.seconds) {
//         setAnimating((p) => ({ ...p, seconds: true }));
//         setTimeout(() => setAnimating((p) => ({ ...p, seconds: false })), 200);
//       }
//       setPrevTime(newTime);
//     }, 1000);
//     return () => clearInterval(timer);
//   }, []);

//   useEffect(() => {
//     let widgetId = null;
//     window.onCaptchaChange = (token) => {
//       if (token) {
//         setCaptchaVerified(true);
//         setCaptchaError("");
//       } else setCaptchaVerified(false);
//     };
//     window.onCaptchaExpired = () => {
//       setCaptchaVerified(false);
//       setCaptchaError("reCAPTCHA has expired. Please verify again.");
//     };
//     window.onCaptchaError = () => {
//       setCaptchaVerified(false);
//       setCaptchaError("reCAPTCHA verification failed. Please try again.");
//     };
//     const renderRecaptcha = () => {
//       const recaptchaElement = document.getElementById("recaptcha-container");
//       if (!recaptchaElement) return false;
//       recaptchaElement.innerHTML = "";
//       if (typeof window.grecaptcha === "undefined" || !window.grecaptcha.render)
//         return false;
//       const siteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;
//       if (!siteKey) {
//         setCaptchaError("Configuration error. Please contact support.");
//         return false;
//       }
//       try {
//         widgetId = window.grecaptcha.render(recaptchaElement, {
//           sitekey: siteKey,
//           callback: window.onCaptchaChange,
//           "expired-callback": window.onCaptchaExpired,
//           "error-callback": window.onCaptchaError,
//         });
//         return true;
//       } catch {
//         setCaptchaError(
//           "Failed to load verification. Please refresh the page.",
//         );
//         return false;
//       }
//     };
//     const initRecaptcha = () => {
//       let attempts = 0;
//       const checkAndRender = () => {
//         attempts++;
//         if (renderRecaptcha()) return true;
//         if (attempts >= 50) {
//           setCaptchaError(
//             "Failed to load verification. Please refresh the page.",
//           );
//           return false;
//         }
//         setTimeout(checkAndRender, 200);
//       };
//       checkAndRender();
//     };
//     const timer = setTimeout(initRecaptcha, 500);
//     return () => {
//       clearTimeout(timer);
//       if (widgetId !== null && window.grecaptcha?.reset) {
//         try {
//           window.grecaptcha.reset(widgetId);
//         } catch (e) {}
//       }
//       delete window.onCaptchaChange;
//       delete window.onCaptchaExpired;
//       delete window.onCaptchaError;
//     };
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (name === "phoneNumber") {
//       const numbersOnly = value.replace(/[^\d]/g, "").slice(0, 15);
//       setFormData({ ...formData, [name]: numbersOnly });
//       if (numbersOnly.length > 0 && numbersOnly.length < 10)
//         setErrors((p) => ({
//           ...p,
//           phoneNumber: "Phone number must be at least 10 digits",
//         }));
//       else setErrors((p) => ({ ...p, phoneNumber: "" }));
//     } else {
//       setFormData({ ...formData, [name]: value });
//       if (name === "fullName") {
//         if (value.trim().length > 0 && value.trim().length < 2)
//           setErrors((p) => ({
//             ...p,
//             fullName: "Name must be at least 2 characters",
//           }));
//         else setErrors((p) => ({ ...p, fullName: "" }));
//       }
//       if (name === "businessName") {
//         if (value.trim().length > 0 && value.trim().length < 2)
//           setErrors((p) => ({
//             ...p,
//             businessName: "Business name must be at least 2 characters",
//           }));
//         else setErrors((p) => ({ ...p, businessName: "" }));
//       }
//       if (name === "linkedinProfile") {
//         if (value.length > 0) {
//           try {
//             const url = new URL(value);
//             if (!url.protocol.match(/^https?:$/))
//               setErrors((p) => ({
//                 ...p,
//                 linkedinProfile: "URL must start with http:// or https://",
//               }));
//             else setErrors((p) => ({ ...p, linkedinProfile: "" }));
//           } catch {
//             setErrors((p) => ({
//               ...p,
//               linkedinProfile: "Please enter a valid URL",
//             }));
//           }
//         } else setErrors((p) => ({ ...p, linkedinProfile: "" }));
//       }
//       if (name === "businessEmail") {
//         const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//         const personalDomains = [
//           "gmail.com",
//           "yahoo.com",
//           "hotmail.com",
//           "outlook.com",
//           "aol.com",
//           "icloud.com",
//           "mail.com",
//           "protonmail.com",
//           "yandex.com",
//           "zoho.com",
//           "gmx.com",
//           "live.com",
//           "msn.com",
//           "yahoo.co.uk",
//           "googlemail.com",
//         ];
//         if (value.length > 0) {
//           if (!emailRegex.test(value))
//             setErrors((p) => ({
//               ...p,
//               businessEmail: "Please enter a valid email address",
//             }));
//           else if (personalDomains.includes(value.split("@")[1]?.toLowerCase()))
//             setErrors((p) => ({
//               ...p,
//               businessEmail:
//                 "Please use a business email address (not Gmail, Yahoo, etc.)",
//             }));
//           else setErrors((p) => ({ ...p, businessEmail: "" }));
//         } else setErrors((p) => ({ ...p, businessEmail: "" }));
//       }
//     }
//   };

//   const validateForm = () => {
//     if (Object.values(errors).some((e) => e !== "")) {
//       setSubmitMessage({
//         type: "error",
//         text: "Please fix all errors before submitting",
//       });
//       setShowToast(true);
//       return false;
//     }
//     if (formData.fullName.trim().length < 2) {
//       setSubmitMessage({
//         type: "error",
//         text: "Name must be at least 2 characters",
//       });
//       setShowToast(true);
//       return false;
//     }
//     if (formData.businessName.trim().length < 2) {
//       setSubmitMessage({
//         type: "error",
//         text: "Business name must be at least 2 characters",
//       });
//       setShowToast(true);
//       return false;
//     }
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRegex.test(formData.businessEmail)) {
//       setSubmitMessage({
//         type: "error",
//         text: "Please enter a valid email address",
//       });
//       setShowToast(true);
//       return false;
//     }
//     const personalDomains = [
//       "gmail.com",
//       "yahoo.com",
//       "hotmail.com",
//       "outlook.com",
//       "aol.com",
//       "icloud.com",
//       "mail.com",
//       "protonmail.com",
//       "yandex.com",
//       "zoho.com",
//       "gmx.com",
//       "live.com",
//       "msn.com",
//       "yahoo.co.uk",
//       "googlemail.com",
//     ];
//     if (
//       personalDomains.includes(
//         formData.businessEmail.split("@")[1]?.toLowerCase(),
//       )
//     ) {
//       setSubmitMessage({
//         type: "error",
//         text: "Please use a business email address (not Gmail, Yahoo, etc.)",
//       });
//       setShowToast(true);
//       return false;
//     }
//     if (formData.phoneNumber.length < 10) {
//       setSubmitMessage({
//         type: "error",
//         text: "Phone number must be at least 10 digits",
//       });
//       setShowToast(true);
//       return false;
//     }
//     if (formData.phoneNumber.length > 15) {
//       setSubmitMessage({
//         type: "error",
//         text: "Phone number cannot exceed 15 digits",
//       });
//       setShowToast(true);
//       return false;
//     }
//     if (formData.linkedinProfile.length > 0) {
//       try {
//         const url = new URL(formData.linkedinProfile);
//         if (!url.protocol.match(/^https?:$/)) {
//           setSubmitMessage({
//             type: "error",
//             text: "URL must start with http:// or https://",
//           });
//           setShowToast(true);
//           return false;
//         }
//       } catch {
//         setSubmitMessage({
//           type: "error",
//           text: "Please enter a valid URL for LinkedIn profile",
//         });
//         setShowToast(true);
//         return false;
//       }
//     }
//     if (!captchaVerified) {
//       setSubmitMessage({
//         type: "error",
//         text: "Please complete the reCAPTCHA verification",
//       });
//       setShowToast(true);
//       return false;
//     }
//     return true;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;
//     setIsSubmitting(true);
//     setSubmitMessage({ type: "", text: "" });
//     try {
//       const recaptchaToken = window.grecaptcha
//         ? window.grecaptcha.getResponse()
//         : "";
//       const response = await fetch("/api/save-founding-member", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ ...formData, recaptchaToken }),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         setSubmitMessage({
//           type: "success",
//           text:
//             data.message ||
//             "Congratulations! Your Founder Access has been secured.",
//         });
//         setShowToast(true);
//         setFormData({
//           fullName: "",
//           businessName: "",
//           businessEmail: "",
//           phoneNumber: "",
//           linkedinProfile: "",
//         });
//         setErrors({
//           fullName: "",
//           businessName: "",
//           businessEmail: "",
//           phoneNumber: "",
//           linkedinProfile: "",
//         });
//         if (window.grecaptcha) {
//           window.grecaptcha.reset();
//           setCaptchaVerified(false);
//         }
//       } else {
//         setSubmitMessage({
//           type: "error",
//           text: data.message || "Failed to submit form. Please try again.",
//         });
//         setShowToast(true);
//       }
//     } catch {
//       setSubmitMessage({
//         type: "error",
//         text: "Network error. Please check your connection and try again.",
//       });
//       setShowToast(true);
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleCloseToast = (event, reason) => {
//     if (reason === "clickaway") return;
//     setShowToast(false);
//   };

//   const timerItems = [
//     {
//       value: timeLeft.days,
//       label: t("foundingMemberMain.timerDays"),
//       isAnimating: animating.days,
//     },
//     {
//       value: timeLeft.hours,
//       label: t("foundingMemberMain.timerHours"),
//       isAnimating: animating.hours,
//     },
//     {
//       value: timeLeft.minutes,
//       label: t("foundingMemberMain.timerMinutes"),
//       isAnimating: animating.minutes,
//     },
//     {
//       value: timeLeft.seconds,
//       label: t("foundingMemberMain.timerSeconds"),
//       isAnimating: animating.seconds,
//     },
//   ];

//   const benefits = [
//     t("foundingMemberMain.benefit1", { discountPercentage }),
//     t("foundingMemberMain.benefit2"),
//     t("foundingMemberMain.benefit3"),
//   ];

//   const textFieldSx = (mb = { xs: 4, lg: 2, xl: 2.5 }) => ({
//     mb,
//     position: "relative",
//     "& .MuiInputBase-input": {
//       textAlign: isArabic ? "right" : "left",
//       fontFamily: "var(--font-outfit)",
//     },
//     "& .MuiInputLabel-root": {
//       right: isArabic ? 28 : "unset",
//       left: isArabic ? "unset" : 14,
//       transformOrigin: isArabic ? "right" : "left",
//     },
//     "& .MuiOutlinedInput-root": {
//       borderRadius: 2,
//       "& fieldset": { borderColor: "#9CA3AF" },
//       "&:hover fieldset": { borderColor: "#9CA3AF" },
//     },
//     "& .MuiFormLabel-asterisk": { display: "none" },
//   });

//   return (
//     <GoogleCaptchaWrapper>
//       <Box
//         aria-label="Join founding members of the best recruitment automation software and AI recruiting platform"
//         sx={{
//           backgroundImage: `url('${IMAGES.FOUNDING_MEMBER_BG}')`,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           position: "relative",
//           py: { xs: 2, sm: 3, md: 4 },
//           direction: isArabic ? "rtl" : "ltr",
//         }}
//       >
//         {/* Toast */}
//         <Snackbar
//           open={showToast}
//           autoHideDuration={3000}
//           onClose={handleCloseToast}
//           anchorOrigin={{ vertical: "top", horizontal: "center" }}
//         >
//           <Alert
//             onClose={handleCloseToast}
//             severity={submitMessage.type}
//             sx={{
//               width: "100%",
//               fontSize: { xs: "14px", sm: "16px" },
//               fontFamily: "var(--font-outfit)",
//             }}
//           >
//             {submitMessage.text}
//           </Alert>
//         </Snackbar>

//         {/* ── Top Nav ── */}
//         <Container
//           maxWidth="xl"
//           disableGutters
//           sx={{ px: { xs: 2, sm: 2, md: 4 } }}
//         >
//           {/* ── Row 1: Logo + Spots (all screens) ── */}
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: "row",
//               justifyContent: "space-between",
//               alignItems: "center",
//               width: "100%",
//               mb: { xs: 1.5, sm: 0 },
//             }}
//           >
//             {/* Logo */}
//             <Box
//               sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}
//               onClick={() => router.push("/")}
//               style={{ cursor: "pointer" }}
//             >
//               <Image
//                 src={IMAGES.GETGEEK_LOGO_WHITE}
//                 alt="Getgeek"
//                 width={125}
//                 height={37}
//               />
//             </Box>

//             {/* sm+ : dropdown + spots inline */}
//             <Box
//               sx={{
//                 display: { xs: "none", sm: "flex" },
//                 alignItems: "center",
//                 gap: 2,
//                 flexShrink: 0,
//               }}
//             >
//               <LangDropdownDark
//                 currentLang={currentLang}
//                 onChange={handleLanguageChange}
//               />
//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 1,
//                   flexShrink: 0,
//                 }}
//               >
//                 <Box
//                   sx={{
//                     width: 12,
//                     height: 12,
//                     borderRadius: "50%",
//                     background:
//                       "linear-gradient(135deg, #FF6B6B 0%, #FF0000 100%)",
//                     position: "relative",
//                     flexShrink: 0,
//                     animation: "pulse 2s ease-in-out infinite",
//                     "@keyframes pulse": {
//                       "0%, 100%": {
//                         transform: "scale(1)",
//                         boxShadow: "0 0 0 0 rgba(255, 107, 107, 0.7)",
//                       },
//                       "50%": {
//                         transform: "scale(1.1)",
//                         boxShadow: "0 0 20px 10px rgba(255, 107, 107, 0)",
//                       },
//                     },
//                     "&::before": {
//                       content: '""',
//                       position: "absolute",
//                       top: "50%",
//                       left: "50%",
//                       transform: "translate(-50%, -50%)",
//                       width: "60%",
//                       height: "60%",
//                       borderRadius: "50%",
//                       background: "rgba(255, 255, 255, 0.3)",
//                       animation: "shimmer 2s ease-in-out infinite",
//                     },
//                     "@keyframes shimmer": {
//                       "0%, 100%": { opacity: 0.3 },
//                       "50%": { opacity: 0.8 },
//                     },
//                   }}
//                 />
//                 <Typography
//                   sx={{
//                     color: "#FFFFFF",
//                     fontSize: "0.9rem",
//                     fontWeight: 400,
//                     fontFamily: "var(--font-outfit)",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   {t("foundingMemberMain.spotsLeft", { remainingSpots })}
//                 </Typography>
//               </Box>
//             </Box>

//             {/* xs only: spots on right of logo */}
//             <Box
//               sx={{
//                 display: { xs: "flex", sm: "none" },
//                 alignItems: "center",
//                 gap: 0.5,
//                 flexShrink: 0,
//               }}
//             >
//               <Box
//                 sx={{
//                   width: 10,
//                   height: 10,
//                   borderRadius: "50%",
//                   background:
//                     "linear-gradient(135deg, #FF6B6B 0%, #FF0000 100%)",
//                   position: "relative",
//                   flexShrink: 0,
//                   animation: "pulse 2s ease-in-out infinite",
//                   "@keyframes pulse": {
//                     "0%, 100%": {
//                       transform: "scale(1)",
//                       boxShadow: "0 0 0 0 rgba(255, 107, 107, 0.7)",
//                     },
//                     "50%": {
//                       transform: "scale(1.1)",
//                       boxShadow: "0 0 20px 10px rgba(255, 107, 107, 0)",
//                     },
//                   },
//                   "&::before": {
//                     content: '""',
//                     position: "absolute",
//                     top: "50%",
//                     left: "50%",
//                     transform: "translate(-50%, -50%)",
//                     width: "60%",
//                     height: "60%",
//                     borderRadius: "50%",
//                     background: "rgba(255, 255, 255, 0.3)",
//                     animation: "shimmer 2s ease-in-out infinite",
//                   },
//                   "@keyframes shimmer": {
//                     "0%, 100%": { opacity: 0.3 },
//                     "50%": { opacity: 0.8 },
//                   },
//                 }}
//               />
//               <Typography
//                 sx={{
//                   color: "#FFFFFF",
//                   fontSize: "0.75rem",
//                   fontWeight: 400,
//                   fontFamily: "var(--font-outfit)",
//                   whiteSpace: "nowrap",
//                 }}
//               >
//                 {t("foundingMemberMain.spotsLeft", { remainingSpots })}
//               </Typography>
//             </Box>
//           </Box>

//           {/* ── Row 2: Dropdown only on xs ── */}
//           <Box
//             sx={{
//               display: { xs: "flex", sm: "none" },
//               justifyContent: "flex-start",
//               mb: { xs: 3 },
//               mt: "10%",
//             }}
//           >
//             <LangDropdownDark
//               currentLang={currentLang}
//               onChange={handleLanguageChange}
//             />
//           </Box>

//           {/* spacer for sm+ to keep mb consistent */}
//           <Box
//             sx={{ display: { xs: "none", sm: "block" }, mb: { sm: 4, md: 6 } }}
//           />
//         </Container>

//         {/* ── Main Content ── */}
//         <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 2, md: 4 } }}>
//           <Grid
//             container
//             spacing={{ xs: 3, md: 6 }}
//             alignItems="center"
//             sx={{ pb: { xs: "2%", md: 0 } }}
//           >
//             {/* Left Side */}
//             <Grid size={{ xs: 12, md: 7, lg: 7, xl: 6 }}>
//               {/* Timer */}
//               <Box
//                 sx={{
//                   bgcolor: "#DC26264D",
//                   backdropFilter: "blur(15px)",
//                   p: { xs: 2, sm: 2.5, md: 3 },
//                   borderRadius: 4,
//                   mb: { xs: 3, sm: 4, md: 5 },
//                   maxWidth: { xs: "fit-content", sm: "fit-content", md: 320 },
//                   mx: { xs: 0, sm: 0, md: 0 },
//                   border: "1px solid #EF4444",
//                   mt: {
//                     xs: 0,
//                     sm: 0,
//                     md: 0,
//                     lg: isArabic ? 0 : "-30%",
//                     xl: isArabic ? "-20%" : "-10%",
//                   },
//                   width: "100%",
//                 }}
//               >
//                 <Box
//                   sx={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 1.5,
//                     mb: 2,
//                     justifyContent: "flex-start",
//                   }}
//                 >
//                   <Typography sx={{ fontSize: "20px" }}>⏰</Typography>
//                   <Typography
//                     sx={{
//                       color: "#fff",
//                       fontSize: { xs: "14px", sm: "14px", md: "14px" },
//                       fontWeight: 400,
//                       fontFamily: "var(--font-outfit)",
//                     }}
//                   >
//                     {t("foundingMemberMain.timerLabel")}
//                   </Typography>
//                 </Box>
//                 <Box
//                   sx={{
//                     display: "flex",
//                     gap: { xs: 1, sm: 1.5, md: 2.8 },
//                     justifyContent: "flex-start",
//                   }}
//                 >
//                   {timerItems.map((item, index) => (
//                     <Box key={index} sx={{ textAlign: "center" }}>
//                       <Box
//                         sx={{
//                           bgcolor: "#DC2626",
//                           borderRadius: 2,
//                           p: { xs: 1, sm: 1.2, md: 2 },
//                           mb: 1.5,
//                           width: { xs: "55px", sm: "55px", md: "50px" },
//                           height: { xs: "55px", sm: "55px", md: "50px" },
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           transform: item.isAnimating
//                             ? "scale(1.2)"
//                             : "scale(1)",
//                           transition: "transform 0.3s ease-out",
//                           boxShadow: item.isAnimating
//                             ? "0 8px 20px rgba(220, 38, 38, 0.6)"
//                             : "0 2px 8px rgba(220, 38, 38, 0.2)",
//                         }}
//                       >
//                         <Typography
//                           sx={{
//                             color: "#fff",
//                             fontSize: { xs: "24px", sm: "24px", md: "20px" },
//                             fontWeight: "bold",
//                             lineHeight: 1,
//                             fontFamily: "var(--font-outfit)",
//                             transform: item.isAnimating
//                               ? "scale(1.1)"
//                               : "scale(1)",
//                             transition: "transform 0.3s ease-out",
//                           }}
//                         >
//                           {String(item.value).padStart(2, "0")}
//                         </Typography>
//                       </Box>
//                       <Typography
//                         sx={{
//                           color: "#fff",
//                           fontSize: { xs: "11px", sm: "11px", md: "12px" },
//                           fontWeight: 400,
//                           fontFamily: "var(--font-outfit)",
//                           opacity: item.isAnimating ? 0.7 : 1,
//                           transition: "opacity 0.3s ease-out",
//                         }}
//                       >
//                         {item.label}
//                       </Typography>
//                     </Box>
//                   ))}
//                 </Box>
//               </Box>

//               {/* Hero Title */}
//               <Typography
//                 variant="h1"
//                 sx={{
//                   color: "#fff",
//                   fontSize: {
//                     xs: "28px",
//                     sm: "48px",
//                     md: "58px",
//                     lg: "40px",
//                     xl: "60px",
//                   },
//                   fontWeight: "bold",
//                   lineHeight: 1.1,
//                   mb: { xs: 2, sm: 2.5, md: 3 },
//                   textShadow: "0 2px 10px rgba(0,0,0,0.3)",
//                   textAlign: isArabic ? "right" : "left",
//                   fontFamily: "var(--font-plusjakarta)",
//                 }}
//               >
//                 {t("foundingMemberMain.heroTitle")}
//               </Typography>

//               {/* Hero Subtitle */}
//               <Typography
//                 sx={{
//                   color: "#fff",
//                   fontSize: { xs: "15px", sm: "17px", md: "21.5px" },
//                   lineHeight: 1.6,
//                   mb: { xs: 3, sm: 3.5, md: 4 },
//                   fontWeight: 500,
//                   textAlign: isArabic ? "right" : "left",
//                   fontFamily: "var(--font-outfit)",
//                 }}
//               >
//                 {t("foundingMemberMain.heroSubtitle")}
//               </Typography>

//               {/* Benefits */}
//               <Box
//                 sx={{
//                   display: "flex",
//                   flexDirection: "column",
//                   gap: { xs: 1.5, sm: 2 },
//                   alignItems: "flex-start",
//                   mb: { xs: 3, sm: 4 },
//                 }}
//               >
//                 {benefits.map((benefit, index) => (
//                   <Box
//                     key={index}
//                     sx={{
//                       display: "flex",
//                       alignItems: "flex-start",
//                       flexDirection: "row",
//                       gap: 1.5,
//                       width: "100%",
//                     }}
//                   >
//                     <Box sx={{ flexShrink: 0, mt: 0.3 }}>
//                       <Image
//                         src={IMAGES.CORRECT_ICON}
//                         alt="check"
//                         width={20}
//                         height={20}
//                       />
//                     </Box>
//                     <Typography
//                       sx={{
//                         color: "#fff",
//                         fontSize: { xs: "14px", sm: "15px", md: "16px" },
//                         fontWeight: 500,
//                         fontFamily: "var(--font-outfit)",
//                         textAlign: isArabic ? "right" : "left",
//                       }}
//                     >
//                       {benefit}
//                     </Typography>
//                   </Box>
//                 ))}
//               </Box>
//             </Grid>

//             {/* Right Side - Form */}
//             <Grid size={{ xs: 12, md: 5, lg: 5, xl: 6 }}>
//               <Box
//                 sx={{
//                   bgcolor: "#fff",
//                   p: { xs: 2.5, sm: 4, md: 5 },
//                   borderRadius: 4,
//                   maxWidth: { xs: "100%", sm: 620 },
//                   ml: isArabic ? 0 : { xs: 0, md: "auto" },
//                   mr: isArabic ? { xs: 0, md: "auto" } : 0,
//                   boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
//                   mb: { xs: "10%", md: 0 },
//                   width: "100%",
//                 }}
//               >
//                 <Typography
//                   variant="h1"
//                   sx={{
//                     fontWeight: "700",
//                     fontSize: { xs: "22px", sm: "28px", md: "30px" },
//                     mb: 1,
//                     textAlign: "center",
//                     color: "#111827",
//                     fontFamily: "var(--font-outfit)",
//                     maxWidth: 410,
//                     mx: "auto",
//                     "@media (min-width: 900px) and (max-width: 1200px)": {
//                       fontSize: "25px",
//                     },
//                   }}
//                 >
//                   {t("foundingMemberMain.formTitle")}
//                 </Typography>
//                 <Typography
//                   sx={{
//                     color: "#4B5563",
//                     mb: { xs: 3, md: 4 },
//                     textAlign: "center",
//                     fontSize: { xs: "14px", sm: "15px", md: "16px" },
//                     fontFamily: "var(--font-outfit)",
//                     fontWeight: 400,
//                     maxWidth: 410,
//                     mt: "3%",
//                     mx: "auto",
//                   }}
//                 >
//                   {t("foundingMemberMain.formSubtitle", { remainingSpots })}
//                 </Typography>

//                 <Box component="form" onSubmit={handleSubmit}>
//                   <TextField
//                     fullWidth
//                     label={
//                       <span style={{ fontFamily: "var(--font-outfit)" }}>
//                         {t("foundingMemberMain.fullName")}{" "}
//                         <span style={{ color: "red" }}>*</span>
//                       </span>
//                     }
//                     name="fullName"
//                     value={formData.fullName}
//                     onChange={handleChange}
//                     required
//                     disabled={isSubmitting}
//                     error={!!errors.fullName}
//                     helperText={errors.fullName}
//                     FormHelperTextProps={{
//                       sx: {
//                         position: "absolute",
//                         bottom: "-20px",
//                         margin: 0,
//                         fontSize: "12px",
//                       },
//                     }}
//                     sx={textFieldSx()}
//                   />
//                   <TextField
//                     fullWidth
//                     label={
//                       <span style={{ fontFamily: "var(--font-outfit)" }}>
//                         {t("foundingMemberMain.businessName")}{" "}
//                         <span style={{ color: "red" }}>*</span>
//                       </span>
//                     }
//                     name="businessName"
//                     value={formData.businessName}
//                     onChange={handleChange}
//                     required
//                     disabled={isSubmitting}
//                     error={!!errors.businessName}
//                     helperText={errors.businessName}
//                     FormHelperTextProps={{
//                       sx: {
//                         position: "absolute",
//                         bottom: "-20px",
//                         margin: 0,
//                         fontSize: "12px",
//                       },
//                     }}
//                     sx={textFieldSx()}
//                   />
//                   <TextField
//                     fullWidth
//                     label={
//                       <span style={{ fontFamily: "var(--font-outfit)" }}>
//                         {t("foundingMemberMain.businessEmail")}{" "}
//                         <span style={{ color: "red" }}>*</span>
//                       </span>
//                     }
//                     name="businessEmail"
//                     type="email"
//                     value={formData.businessEmail}
//                     onChange={handleChange}
//                     required
//                     disabled={isSubmitting}
//                     error={!!errors.businessEmail}
//                     helperText={errors.businessEmail}
//                     FormHelperTextProps={{
//                       sx: {
//                         position: "absolute",
//                         bottom: "-20px",
//                         margin: 0,
//                         fontSize: "12px",
//                       },
//                     }}
//                     sx={textFieldSx()}
//                   />
//                   <TextField
//                     fullWidth
//                     label={
//                       <span style={{ fontFamily: "var(--font-outfit)" }}>
//                         {t("foundingMemberMain.phoneNumber")}{" "}
//                         <span style={{ color: "red" }}>*</span>
//                       </span>
//                     }
//                     name="phoneNumber"
//                     value={formData.phoneNumber}
//                     onChange={handleChange}
//                     required
//                     disabled={isSubmitting}
//                     error={!!errors.phoneNumber}
//                     helperText={errors.phoneNumber}
//                     FormHelperTextProps={{
//                       sx: {
//                         position: "absolute",
//                         bottom: "-20px",
//                         margin: 0,
//                         fontSize: "12px",
//                       },
//                     }}
//                     sx={textFieldSx()}
//                   />
//                   <TextField
//                     fullWidth
//                     label={t("foundingMemberMain.linkedinProfile")}
//                     name="linkedinProfile"
//                     value={formData.linkedinProfile}
//                     onChange={handleChange}
//                     disabled={isSubmitting}
//                     error={!!errors.linkedinProfile}
//                     helperText={errors.linkedinProfile}
//                     FormHelperTextProps={{
//                       sx: {
//                         position: "absolute",
//                         bottom: "-20px",
//                         margin: 0,
//                         fontSize: "12px",
//                       },
//                     }}
//                     sx={textFieldSx({ mb: 2 })}
//                   />

//                   <Box
//                     sx={{
//                       mb: 2,
//                       display: "flex",
//                       justifyContent: "flex-start",
//                     }}
//                   >
//                     <div
//                       id="recaptcha-container"
//                       style={{
//                         transform: "scale(0.85)",
//                         transformOrigin: isArabic
//                           ? "right center"
//                           : "left center",
//                       }}
//                     />
//                   </Box>
//                   {captchaError && (
//                     <Typography
//                       sx={{
//                         color: "#d32f2f",
//                         fontSize: "12px",
//                         mb: 2,
//                         textAlign: "center",
//                       }}
//                     >
//                       {captchaError}
//                     </Typography>
//                   )}

//                   <Button
//                     fullWidth
//                     type="submit"
//                     variant="contained"
//                     disabled={isSubmitting || !captchaVerified}
//                     sx={{
//                       fontFamily: "var(--font-outfit)",
//                       bgcolor: "#7c3aed",
//                       color: "#fff",
//                       py: { xs: 1.5, sm: 1.8 },
//                       fontSize: { xs: "14px", sm: "16px", md: "18px" },
//                       fontWeight: "600",
//                       textTransform: "none",
//                       borderRadius: 2.5,
//                       boxShadow: "none",
//                       "&:hover": { bgcolor: "#7c3aed", boxShadow: "none" },
//                       "&:disabled": { bgcolor: "#9ca3af", color: "#fff" },
//                     }}
//                     endIcon={
//                       <ArrowForwardIcon
//                         sx={{
//                           fontSize: { xs: "18px", sm: "22px" },
//                           transform: isArabic ? "scaleX(-1)" : "none",
//                           mt: isArabic ? "30%" : 0,
//                           mr: isArabic ? "30%" : 0,
//                         }}
//                       />
//                     }
//                   >
//                     {isSubmitting
//                       ? t("foundingMemberMain.submitting")
//                       : t("foundingMemberMain.submitBtn")}
//                   </Button>

//                   <Box
//                     sx={{ display: "flex", justifyContent: "center", mt: 2.5 }}
//                   >
//                     <Box
//                       sx={{
//                         display: "flex",
//                         alignItems: "flex-start",
//                         flexDirection: "row",
//                         gap: 1,
//                         maxWidth: { xs: "100%", sm: "600px" },
//                         flexWrap: "nowrap",
//                       }}
//                     >
//                       <Box sx={{ flexShrink: 0, mt: 0.2 }}>
//                         <LockIcon style={{ fontSize: 20, color: "#6B7280" }} />
//                       </Box>
//                       <Typography
//                         sx={{
//                           color: "#6B7280",
//                           lineHeight: 1.5,
//                           fontSize: { xs: "13px", sm: "15px", md: "16px" },
//                           fontFamily: "var(--font-outfit)",
//                           fontWeight: 400,
//                           textAlign: isArabic ? "right" : "center",
//                         }}
//                       >
//                         {t("foundingMemberMain.formNote")}
//                       </Typography>
//                     </Box>
//                   </Box>
//                 </Box>
//               </Box>
//             </Grid>
//           </Grid>
//         </Container>
//       </Box>
//     </GoogleCaptchaWrapper>
//   );
// };

// export default FoundingMemberMainSection;


"use client";
import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Grid,
  Snackbar,
  Alert,
  CircularProgress,
} from "@mui/material";
import Image from "next/image";
import "../app/globals.css";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useRouter } from "next/navigation";
import GoogleCaptchaWrapper from "./GoogleCaptchaWrapper";
import LockIcon from "@mui/icons-material/Lock";
import { IMAGES } from "../constants/images";
import { useTranslation } from "react-i18next";

const FLAG_EN =
  "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/FlagOne.webp";
const FLAG_AR =
  "https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/FlagArabic.webp";

const LANG_OPTIONS = [
  { value: "en", label: "English", flag: FLAG_EN },
  { value: "ar", label: "العربية", flag: FLAG_AR },
];
// ── Custom Language Dropdown (white variant for dark bg) ────
const LangDropdownDark = ({ currentLang, onChange }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const selected =
    LANG_OPTIONS.find((o) => o.value === currentLang) || LANG_OPTIONS[0];

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <Box ref={ref} sx={{ position: "relative", zIndex: 1300, flexShrink: 0 }}>
      {/* Trigger */}
      <Box
        onClick={() => setOpen((prev) => !prev)}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          height: "34px",
          padding: "0 10px",
          borderRadius: "8px",
          border: "1.5px solid",
          borderColor: open ? "#fff" : "rgba(255,255,255,0.4)",
          backgroundColor: open
            ? "rgba(255,255,255,0.15)"
            : "rgba(255,255,255,0.08)",
          cursor: "pointer",
          userSelect: "none",
          minWidth: "130px",
          maxWidth: "150px",
          transition: "all 0.2s ease",
          "&:hover": {
            borderColor: "#fff",
            backgroundColor: "rgba(255,255,255,0.15)",
          },
        }}
      >
        <Box
          sx={{
            flex: 1,
            fontSize: { xs: "12px", sm: "13px" },
            fontWeight: 500,
            color: "#fff",
            fontFamily: "var(--font-outfit)",
            whiteSpace: "nowrap",
            display: "flex",
            alignItems: "center",
            gap: "5px",
            overflow: "hidden",
          }}
        >
          <Box
            component="img"
            src={selected.flag}
            alt={selected.label}
            sx={{
              width: 22,
              height: 15,
              borderRadius: "3px",
              objectFit: "cover",
              flexShrink: 0,
            }}
          />
          <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
            {selected.label}
          </span>
        </Box>
        <Box
          sx={{
            color: "rgba(255,255,255,0.7)",
            display: "flex",
            alignItems: "center",
            flexShrink: 0,
          }}
        >
          <svg
            width="11"
            height="11"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{
              transition: "transform 0.2s ease",
              transform: open ? "rotate(180deg)" : "rotate(0deg)",
            }}
          >
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </Box>
      </Box>

      {/* Dropdown */}
      {open && (
        <Box
          sx={{
            position: "absolute",
            top: "calc(100% + 8px)",
            left: 0,
            right: 0,
            backgroundColor: "#fff",
            borderRadius: "10px",
            border: "1.5px solid #F0F0F0",
            boxShadow: "0px 12px 32px rgba(0,0,0,0.2)",
            zIndex: 9999,
            overflow: "hidden",
            minWidth: "140px",
          }}
        >
          <Box
            sx={{ padding: "8px 14px 6px", borderBottom: "1px solid #F5F5F5" }}
          >
            {/* <Box
              sx={{
                fontSize: "11px",
                fontWeight: 600,
                color: "#AAAAAA",
                letterSpacing: "0.06em",
                textTransform: "uppercase",
                fontFamily: "var(--font-outfit)",
              }}
            >
              Language
            </Box> */}
          </Box>
          {LANG_OPTIONS.map((option) => {
            const isActive = currentLang === option.value;
            return (
              <Box
                key={option.value}
                onClick={() => {
                  onChange(option.value);
                  setOpen(false);
                }}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  padding: "10px 14px",
                  cursor: "pointer",
                  backgroundColor: isActive ? "#FFFBF0" : "#fff",
                  borderLeft: isActive
                    ? "3px solid #FFB200"
                    : "3px solid transparent",
                  transition: "all 0.15s ease",
                  "&:hover": { backgroundColor: "#FFFBF0" },
                }}
              >
                <Box
                  component="img"
                  src={option.flag}
                  alt={option.label}
                  sx={{
                    width: 26,
                    height: 18,
                    borderRadius: "3px",
                    objectFit: "cover",
                    flexShrink: 0,
                  }}
                />
                <Box
                  sx={{
                    flex: 1,
                    fontSize: "14px",
                    fontWeight: isActive ? 600 : 400,
                    color: isActive ? "#FFB200" : "#333",
                    fontFamily:
                      option.value === "ar"
                        ? "sans-serif"
                        : "var(--font-outfit)",
                  }}
                >
                  {option.label}
                </Box>
                {isActive && (
                  <Box
                    sx={{
                      width: "18px",
                      height: "18px",
                      borderRadius: "50%",
                      backgroundColor: "#FFB200",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <svg width="10" height="10" viewBox="0 0 12 12" fill="none">
                      <path
                        d="M2 6L5 9L10 3"
                        stroke="white"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </Box>
                )}
              </Box>
            );
          })}
        </Box>
      )}
    </Box>
  );
};

// ── Main Component ───────────────────────────────────────────
const FoundingMemberMainSection = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";
  const router = useRouter();
  const [currentLang, setCurrentLang] = useState(i18n.language || "en");

  const handleLanguageChange = (newLang) => {
    setCurrentLang(newLang);
    i18n.changeLanguage(newLang);
    document.dir = newLang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = newLang;
  };

  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [animating, setAnimating] = useState({
    days: false,
    hours: false,
    minutes: false,
    seconds: false,
  });
  const [prevTime, setPrevTime] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [remainingSpots, setRemainingSpots] = useState(43);
  const [discountPercentage, setDiscountPercentage] = useState(60);
  const [formData, setFormData] = useState({
    fullName: "",
    businessName: "",
    businessEmail: "",
    phoneNumber: "",
    linkedinProfile: "",
  });
  const [errors, setErrors] = useState({
    fullName: "",
    businessName: "",
    businessEmail: "",
    phoneNumber: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState({ type: "", text: "" });
  const [showToast, setShowToast] = useState(false);
  const [captchaError, setCaptchaError] = useState("");
  // ── Email verification (Reoon Power Mode via backend) loading flag ───────
  const [emailVerifying, setEmailVerifying] = useState(false);

  useEffect(() => {
    const calculateTimeLeft = () => {
      try {
        const offersData = localStorage.getItem("offersData");
        if (!offersData)
          return { days: 7, hours: 15, minutes: 30, seconds: 45 };
        const parsedData = JSON.parse(offersData);
        const spots = parsedData?.data?.remainingSpots;
        if (spots !== undefined && spots !== null) setRemainingSpots(spots);
        const discount = parsedData?.data?.discountPercentage;
        if (discount !== undefined && discount !== null)
          setDiscountPercentage(discount);
        const expiryTime = parsedData?.data?.ExpiryTime;
        if (!expiryTime || !Array.isArray(expiryTime) || expiryTime.length < 4)
          return { days: 7, hours: 15, minutes: 30, seconds: 45 };
        const [targetDays, targetHours, targetMinutes, targetSeconds] =
          expiryTime;
        const totalSeconds =
          targetDays * 86400 +
          targetHours * 3600 +
          targetMinutes * 60 +
          targetSeconds;
        const now = Math.floor(Date.now() / 1000);
        const savedTimestamp = parsedData?.data?.timestamp || now;
        const elapsed = now - savedTimestamp;
        const remaining = Math.max(0, totalSeconds - elapsed);
        return {
          days: Math.floor(remaining / 86400),
          hours: Math.floor((remaining % 86400) / 3600),
          minutes: Math.floor((remaining % 3600) / 60),
          seconds: remaining % 60,
        };
      } catch {
        return { days: 7, hours: 15, minutes: 30, seconds: 45 };
      }
    };
    const initial = calculateTimeLeft();
    setTimeLeft(initial);
    setPrevTime(initial);
    const timer = setInterval(() => {
      const newTime = calculateTimeLeft();
      if (
        newTime.days === 0 &&
        newTime.hours === 0 &&
        newTime.minutes === 0 &&
        newTime.seconds === 0
      )
        clearInterval(timer);
      setTimeLeft(newTime);
      if (prevTime.days !== newTime.days) {
        setAnimating((p) => ({ ...p, days: true }));
        setTimeout(() => setAnimating((p) => ({ ...p, days: false })), 200);
      }
      if (prevTime.hours !== newTime.hours) {
        setAnimating((p) => ({ ...p, hours: true }));
        setTimeout(() => setAnimating((p) => ({ ...p, hours: false })), 200);
      }
      if (prevTime.minutes !== newTime.minutes) {
        setAnimating((p) => ({ ...p, minutes: true }));
        setTimeout(() => setAnimating((p) => ({ ...p, minutes: false })), 200);
      }
      if (prevTime.seconds !== newTime.seconds) {
        setAnimating((p) => ({ ...p, seconds: true }));
        setTimeout(() => setAnimating((p) => ({ ...p, seconds: false })), 200);
      }
      setPrevTime(newTime);
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  // ── reCAPTCHA v3 (invisible) ──────────────────────────────────────────────
  // No widget to render — grecaptcha.execute() is called on demand (right
  // before submitting the form) and silently returns a token in the
  // background, same approach as the Book Demo form.
  const getRecaptchaToken = (action = "founding_member_form") =>
    new Promise((resolve, reject) => {
      if (typeof window === "undefined" || !window.grecaptcha) {
        reject(new Error("reCAPTCHA not loaded yet. Please try again."));
        return;
      }
      const siteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;
      try {
        window.grecaptcha.ready(() => {
          window.grecaptcha
            .execute(siteKey, { action })
            .then(resolve)
            .catch(() =>
              reject(
                new Error("reCAPTCHA verification failed. Please try again."),
              ),
            );
        });
      } catch (e) {
        reject(new Error("reCAPTCHA verification failed. Please try again."));
      }
    });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "phoneNumber") {
      const numbersOnly = value.replace(/[^\d]/g, "").slice(0, 15);
      setFormData({ ...formData, [name]: numbersOnly });
      if (numbersOnly.length > 0 && numbersOnly.length < 10)
        setErrors((p) => ({
          ...p,
          phoneNumber: "Phone number must be at least 10 digits",
        }));
      else setErrors((p) => ({ ...p, phoneNumber: "" }));
    } else {
      setFormData({ ...formData, [name]: value });
      if (name === "fullName") {
        if (value.trim().length > 0 && value.trim().length < 2)
          setErrors((p) => ({
            ...p,
            fullName: "Name must be at least 2 characters",
          }));
        else setErrors((p) => ({ ...p, fullName: "" }));
      }
      if (name === "businessName") {
        if (value.trim().length > 0 && value.trim().length < 2)
          setErrors((p) => ({
            ...p,
            businessName: "Business name must be at least 2 characters",
          }));
        else setErrors((p) => ({ ...p, businessName: "" }));
      }
      if (name === "linkedinProfile") {
        if (value.length > 0) {
          try {
            const url = new URL(value);
            if (!url.protocol.match(/^https?:$/))
              setErrors((p) => ({
                ...p,
                linkedinProfile: "URL must start with http:// or https://",
              }));
            else setErrors((p) => ({ ...p, linkedinProfile: "" }));
          } catch {
            setErrors((p) => ({
              ...p,
              linkedinProfile: "Please enter a valid URL",
            }));
          }
        } else setErrors((p) => ({ ...p, linkedinProfile: "" }));
      }
      // ── Any email is allowed now (business-only domain restriction removed) ──
      if (name === "businessEmail") {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (value.length > 0) {
          if (!emailRegex.test(value))
            setErrors((p) => ({
              ...p,
              businessEmail: "Please enter a valid email address",
            }));
          else setErrors((p) => ({ ...p, businessEmail: "" }));
        } else setErrors((p) => ({ ...p, businessEmail: "" }));
      }
    }
  };

  // ── Email verify (Reoon Power Mode via backend API) ──────────────────────
  const verifyEmail = async (email) => {
    try {
      setEmailVerifying(true);
      const res = await fetch(
        `${process.env.NEXT_PUBLIC_NEST_BACKEND_URL}/email-verification/verify`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        },
      );
      const json = await res.json();

      if (!res.ok || !json?.success || !json?.data) {
        return {
          valid: false,
          message:
            json?.data?.message ||
            json?.message ||
            "Email verification failed. Please try again.",
        };
      }

      const { isSafeToSend, message } = json.data;
      return {
        valid: !!isSafeToSend,
        message,
      };
    } catch {
      return {
        valid: false,
        message: "Email verification failed. Please try again.",
      };
    } finally {
      setEmailVerifying(false);
    }
  };

  const validateForm = () => {
    if (Object.values(errors).some((e) => e !== "")) {
      setSubmitMessage({
        type: "error",
        text: "Please fix all errors before submitting",
      });
      setShowToast(true);
      return false;
    }
    if (formData.fullName.trim().length < 2) {
      setSubmitMessage({
        type: "error",
        text: "Name must be at least 2 characters",
      });
      setShowToast(true);
      return false;
    }
    if (formData.businessName.trim().length < 2) {
      setSubmitMessage({
        type: "error",
        text: "Business name must be at least 2 characters",
      });
      setShowToast(true);
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.businessEmail)) {
      setSubmitMessage({
        type: "error",
        text: "Please enter a valid email address",
      });
      setShowToast(true);
      return false;
    }
    // ── Business-only email domain restriction removed — any email is fine ──
    if (formData.phoneNumber.length < 10) {
      setSubmitMessage({
        type: "error",
        text: "Phone number must be at least 10 digits",
      });
      setShowToast(true);
      return false;
    }
    if (formData.phoneNumber.length > 15) {
      setSubmitMessage({
        type: "error",
        text: "Phone number cannot exceed 15 digits",
      });
      setShowToast(true);
      return false;
    }
    if (formData.linkedinProfile.length > 0) {
      try {
        const url = new URL(formData.linkedinProfile);
        if (!url.protocol.match(/^https?:$/)) {
          setSubmitMessage({
            type: "error",
            text: "URL must start with http:// or https://",
          });
          setShowToast(true);
          return false;
        }
      } catch {
        setSubmitMessage({
          type: "error",
          text: "Please enter a valid URL for LinkedIn profile",
        });
        setShowToast(true);
        return false;
      }
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setSubmitMessage({ type: "", text: "" });

    // ── Email verification (Reoon Power Mode) before submitting ────────────
    const nb = await verifyEmail(formData.businessEmail.trim());
    if (!nb.valid) {
      setErrors((p) => ({ ...p, businessEmail: nb.message }));
      return;
    }

    // ── reCAPTCHA v3 token, generated right before submit ───────────────────
    let recaptchaToken;
    try {
      recaptchaToken = await getRecaptchaToken("founding_member_form");
      setCaptchaError("");
    } catch (err) {
      setCaptchaError(
        err.message || "reCAPTCHA verification failed. Please try again.",
      );
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await fetch("/api/save-founding-member", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...formData, recaptchaToken }),
      });
      const data = await response.json();
      if (response.ok) {
        setSubmitMessage({
          type: "success",
          text:
            data.message ||
            "Congratulations! Your Founder Access has been secured.",
        });
        setShowToast(true);
        setFormData({
          fullName: "",
          businessName: "",
          businessEmail: "",
          phoneNumber: "",
          linkedinProfile: "",
        });
        setErrors({
          fullName: "",
          businessName: "",
          businessEmail: "",
          phoneNumber: "",
          linkedinProfile: "",
        });
      } else {
        setSubmitMessage({
          type: "error",
          text: data.message || "Failed to submit form. Please try again.",
        });
        setShowToast(true);
      }
    } catch {
      setSubmitMessage({
        type: "error",
        text: "Network error. Please check your connection and try again.",
      });
      setShowToast(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCloseToast = (event, reason) => {
    if (reason === "clickaway") return;
    setShowToast(false);
  };

  const timerItems = [
    {
      value: timeLeft.days,
      label: t("foundingMemberMain.timerDays"),
      isAnimating: animating.days,
    },
    {
      value: timeLeft.hours,
      label: t("foundingMemberMain.timerHours"),
      isAnimating: animating.hours,
    },
    {
      value: timeLeft.minutes,
      label: t("foundingMemberMain.timerMinutes"),
      isAnimating: animating.minutes,
    },
    {
      value: timeLeft.seconds,
      label: t("foundingMemberMain.timerSeconds"),
      isAnimating: animating.seconds,
    },
  ];

  const benefits = [
    t("foundingMemberMain.benefit1", { discountPercentage }),
    t("foundingMemberMain.benefit2"),
    t("foundingMemberMain.benefit3"),
  ];

  const textFieldSx = (mb = { xs: 4, lg: 2, xl: 2.5 }) => ({
    mb,
    position: "relative",
    "& .MuiInputBase-input": {
      textAlign: isArabic ? "right" : "left",
      fontFamily: "var(--font-outfit)",
    },
    "& .MuiInputLabel-root": {
      right: isArabic ? 28 : "unset",
      left: isArabic ? "unset" : 14,
      transformOrigin: isArabic ? "right" : "left",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
      "& fieldset": { borderColor: "#9CA3AF" },
      "&:hover fieldset": { borderColor: "#9CA3AF" },
    },
    "& .MuiFormLabel-asterisk": { display: "none" },
  });

  return (
    <GoogleCaptchaWrapper>
      <Box
        aria-label="Join founding members of the best recruitment automation software and AI recruiting platform"
        sx={{
          backgroundImage: `url('${IMAGES.FOUNDING_MEMBER_BG}')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
          py: { xs: 2, sm: 3, md: 4 },
          direction: isArabic ? "rtl" : "ltr",
        }}
      >
        {/* Toast */}
        <Snackbar
          open={showToast}
          autoHideDuration={3000}
          onClose={handleCloseToast}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseToast}
            severity={submitMessage.type}
            sx={{
              width: "100%",
              fontSize: { xs: "14px", sm: "16px" },
              fontFamily: "var(--font-outfit)",
            }}
          >
            {submitMessage.text}
          </Alert>
        </Snackbar>

        {/* ── Top Nav ── */}
        <Container
          maxWidth="xl"
          disableGutters
          sx={{ px: { xs: 2, sm: 2, md: 4 } }}
        >
          {/* ── Row 1: Logo + Spots (all screens) ── */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              mb: { xs: 1.5, sm: 0 },
            }}
          >
            {/* Logo */}
            <Box
              sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}
              onClick={() => router.push("/")}
              style={{ cursor: "pointer" }}
            >
              <Image
                src={IMAGES.GETGEEK_LOGO_WHITE}
                alt="Getgeek"
                width={125}
                height={37}
              />
            </Box>

            {/* sm+ : dropdown + spots inline */}
            <Box
              sx={{
                display: { xs: "none", sm: "flex" },
                alignItems: "center",
                gap: 2,
                flexShrink: 0,
              }}
            >
              <LangDropdownDark
                currentLang={currentLang}
                onChange={handleLanguageChange}
              />
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  flexShrink: 0,
                }}
              >
                <Box
                  sx={{
                    width: 12,
                    height: 12,
                    borderRadius: "50%",
                    background:
                      "linear-gradient(135deg, #FF6B6B 0%, #FF0000 100%)",
                    position: "relative",
                    flexShrink: 0,
                    animation: "pulse 2s ease-in-out infinite",
                    "@keyframes pulse": {
                      "0%, 100%": {
                        transform: "scale(1)",
                        boxShadow: "0 0 0 0 rgba(255, 107, 107, 0.7)",
                      },
                      "50%": {
                        transform: "scale(1.1)",
                        boxShadow: "0 0 20px 10px rgba(255, 107, 107, 0)",
                      },
                    },
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: "60%",
                      height: "60%",
                      borderRadius: "50%",
                      background: "rgba(255, 255, 255, 0.3)",
                      animation: "shimmer 2s ease-in-out infinite",
                    },
                    "@keyframes shimmer": {
                      "0%, 100%": { opacity: 0.3 },
                      "50%": { opacity: 0.8 },
                    },
                  }}
                />
                <Typography
                  sx={{
                    color: "#FFFFFF",
                    fontSize: "0.9rem",
                    fontWeight: 400,
                    fontFamily: "var(--font-outfit)",
                    whiteSpace: "nowrap",
                  }}
                >
                  {t("foundingMemberMain.spotsLeft", { remainingSpots })}
                </Typography>
              </Box>
            </Box>

            {/* xs only: spots on right of logo */}
            <Box
              sx={{
                display: { xs: "flex", sm: "none" },
                alignItems: "center",
                gap: 0.5,
                flexShrink: 0,
              }}
            >
              <Box
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  background:
                    "linear-gradient(135deg, #FF6B6B 0%, #FF0000 100%)",
                  position: "relative",
                  flexShrink: 0,
                  animation: "pulse 2s ease-in-out infinite",
                  "@keyframes pulse": {
                    "0%, 100%": {
                      transform: "scale(1)",
                      boxShadow: "0 0 0 0 rgba(255, 107, 107, 0.7)",
                    },
                    "50%": {
                      transform: "scale(1.1)",
                      boxShadow: "0 0 20px 10px rgba(255, 107, 107, 0)",
                    },
                  },
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "60%",
                    height: "60%",
                    borderRadius: "50%",
                    background: "rgba(255, 255, 255, 0.3)",
                    animation: "shimmer 2s ease-in-out infinite",
                  },
                  "@keyframes shimmer": {
                    "0%, 100%": { opacity: 0.3 },
                    "50%": { opacity: 0.8 },
                  },
                }}
              />
              <Typography
                sx={{
                  color: "#FFFFFF",
                  fontSize: "0.75rem",
                  fontWeight: 400,
                  fontFamily: "var(--font-outfit)",
                  whiteSpace: "nowrap",
                }}
              >
                {t("foundingMemberMain.spotsLeft", { remainingSpots })}
              </Typography>
            </Box>
          </Box>

          {/* ── Row 2: Dropdown only on xs ── */}
          <Box
            sx={{
              display: { xs: "flex", sm: "none" },
              justifyContent: "flex-start",
              mb: { xs: 3 },
              mt: "10%",
            }}
          >
            <LangDropdownDark
              currentLang={currentLang}
              onChange={handleLanguageChange}
            />
          </Box>

          {/* spacer for sm+ to keep mb consistent */}
          <Box
            sx={{ display: { xs: "none", sm: "block" }, mb: { sm: 4, md: 6 } }}
          />
        </Container>

        {/* ── Main Content ── */}
        <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 2, md: 4 } }}>
          <Grid
            container
            spacing={{ xs: 3, md: 6 }}
            alignItems="center"
            sx={{ pb: { xs: "2%", md: 0 } }}
          >
            {/* Left Side */}
            <Grid size={{ xs: 12, md: 7, lg: 7, xl: 6 }}>
              {/* Timer */}
              <Box
                sx={{
                  bgcolor: "#DC26264D",
                  backdropFilter: "blur(15px)",
                  p: { xs: 2, sm: 2.5, md: 3 },
                  borderRadius: 4,
                  mb: { xs: 3, sm: 4, md: 5 },
                  maxWidth: { xs: "fit-content", sm: "fit-content", md: 320 },
                  mx: { xs: 0, sm: 0, md: 0 },
                  border: "1px solid #EF4444",
                  mt: {
                    xs: 0,
                    sm: 0,
                    md: 0,
                    lg: isArabic ? 0 : "-30%",
                    xl: isArabic ? "-20%" : "-10%",
                  },
                  width: "100%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    mb: 2,
                    justifyContent: "flex-start",
                  }}
                >
                  <Typography sx={{ fontSize: "20px" }}>⏰</Typography>
                  <Typography
                    sx={{
                      color: "#fff",
                      fontSize: { xs: "14px", sm: "14px", md: "14px" },
                      fontWeight: 400,
                      fontFamily: "var(--font-outfit)",
                    }}
                  >
                    {t("foundingMemberMain.timerLabel")}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    gap: { xs: 1, sm: 1.5, md: 2.8 },
                    justifyContent: "flex-start",
                  }}
                >
                  {timerItems.map((item, index) => (
                    <Box key={index} sx={{ textAlign: "center" }}>
                      <Box
                        sx={{
                          bgcolor: "#DC2626",
                          borderRadius: 2,
                          p: { xs: 1, sm: 1.2, md: 2 },
                          mb: 1.5,
                          width: { xs: "55px", sm: "55px", md: "50px" },
                          height: { xs: "55px", sm: "55px", md: "50px" },
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          transform: item.isAnimating
                            ? "scale(1.2)"
                            : "scale(1)",
                          transition: "transform 0.3s ease-out",
                          boxShadow: item.isAnimating
                            ? "0 8px 20px rgba(220, 38, 38, 0.6)"
                            : "0 2px 8px rgba(220, 38, 38, 0.2)",
                        }}
                      >
                        <Typography
                          sx={{
                            color: "#fff",
                            fontSize: { xs: "24px", sm: "24px", md: "20px" },
                            fontWeight: "bold",
                            lineHeight: 1,
                            fontFamily: "var(--font-outfit)",
                            transform: item.isAnimating
                              ? "scale(1.1)"
                              : "scale(1)",
                            transition: "transform 0.3s ease-out",
                          }}
                        >
                          {String(item.value).padStart(2, "0")}
                        </Typography>
                      </Box>
                      <Typography
                        sx={{
                          color: "#fff",
                          fontSize: { xs: "11px", sm: "11px", md: "12px" },
                          fontWeight: 400,
                          fontFamily: "var(--font-outfit)",
                          opacity: item.isAnimating ? 0.7 : 1,
                          transition: "opacity 0.3s ease-out",
                        }}
                      >
                        {item.label}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>

              {/* Hero Title */}
              <Typography
                variant="h1"
                sx={{
                  color: "#fff",
                  fontSize: {
                    xs: "28px",
                    sm: "48px",
                    md: "58px",
                    lg: "40px",
                    xl: "60px",
                  },
                  fontWeight: "bold",
                  lineHeight: 1.1,
                  mb: { xs: 2, sm: 2.5, md: 3 },
                  textShadow: "0 2px 10px rgba(0,0,0,0.3)",
                  textAlign: isArabic ? "right" : "left",
                  fontFamily: "var(--font-plusjakarta)",
                }}
              >
                {t("foundingMemberMain.heroTitle")}
              </Typography>

              {/* Hero Subtitle */}
              <Typography
                sx={{
                  color: "#fff",
                  fontSize: { xs: "15px", sm: "17px", md: "21.5px" },
                  lineHeight: 1.6,
                  mb: { xs: 3, sm: 3.5, md: 4 },
                  fontWeight: 500,
                  textAlign: isArabic ? "right" : "left",
                  fontFamily: "var(--font-outfit)",
                }}
              >
                {t("foundingMemberMain.heroSubtitle")}
              </Typography>

              {/* Benefits */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: { xs: 1.5, sm: 2 },
                  alignItems: "flex-start",
                  mb: { xs: 3, sm: 4 },
                }}
              >
                {benefits.map((benefit, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      flexDirection: "row",
                      gap: 1.5,
                      width: "100%",
                    }}
                  >
                    <Box sx={{ flexShrink: 0, mt: 0.3 }}>
                      <Image
                        src={IMAGES.CORRECT_ICON}
                        alt="check"
                        width={20}
                        height={20}
                      />
                    </Box>
                    <Typography
                      sx={{
                        color: "#fff",
                        fontSize: { xs: "14px", sm: "15px", md: "16px" },
                        fontWeight: 500,
                        fontFamily: "var(--font-outfit)",
                        textAlign: isArabic ? "right" : "left",
                      }}
                    >
                      {benefit}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Grid>

            {/* Right Side - Form */}
            <Grid size={{ xs: 12, md: 5, lg: 5, xl: 6 }}>
              <Box
                sx={{
                  bgcolor: "#fff",
                  p: { xs: 2.5, sm: 4, md: 5 },
                  borderRadius: 4,
                  maxWidth: { xs: "100%", sm: 620 },
                  ml: isArabic ? 0 : { xs: 0, md: "auto" },
                  mr: isArabic ? { xs: 0, md: "auto" } : 0,
                  boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
                  mb: { xs: "10%", md: 0 },
                  width: "100%",
                }}
              >
                <Typography
                  variant="h1"
                  sx={{
                    fontWeight: "700",
                    fontSize: { xs: "22px", sm: "28px", md: "30px" },
                    mb: 1,
                    textAlign: "center",
                    color: "#111827",
                    fontFamily: "var(--font-outfit)",
                    maxWidth: 410,
                    mx: "auto",
                    "@media (min-width: 900px) and (max-width: 1200px)": {
                      fontSize: "25px",
                    },
                  }}
                >
                  {t("foundingMemberMain.formTitle")}
                </Typography>
                <Typography
                  sx={{
                    color: "#4B5563",
                    mb: { xs: 3, md: 4 },
                    textAlign: "center",
                    fontSize: { xs: "14px", sm: "15px", md: "16px" },
                    fontFamily: "var(--font-outfit)",
                    fontWeight: 400,
                    maxWidth: 410,
                    mt: "3%",
                    mx: "auto",
                  }}
                >
                  {t("foundingMemberMain.formSubtitle", { remainingSpots })}
                </Typography>

                <Box component="form" onSubmit={handleSubmit}>
                  <TextField
                    fullWidth
                    label={
                      <span style={{ fontFamily: "var(--font-outfit)" }}>
                        {t("foundingMemberMain.fullName")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleChange}
                    required
                    disabled={isSubmitting || emailVerifying}
                    error={!!errors.fullName}
                    helperText={errors.fullName}
                    FormHelperTextProps={{
                      sx: {
                        position: "absolute",
                        bottom: "-20px",
                        margin: 0,
                        fontSize: "12px",
                      },
                    }}
                    sx={textFieldSx()}
                  />
                  <TextField
                    fullWidth
                    label={
                      <span style={{ fontFamily: "var(--font-outfit)" }}>
                        {t("foundingMemberMain.businessName")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="businessName"
                    value={formData.businessName}
                    onChange={handleChange}
                    required
                    disabled={isSubmitting || emailVerifying}
                    error={!!errors.businessName}
                    helperText={errors.businessName}
                    FormHelperTextProps={{
                      sx: {
                        position: "absolute",
                        bottom: "-20px",
                        margin: 0,
                        fontSize: "12px",
                      },
                    }}
                    sx={textFieldSx()}
                  />
                  <TextField
                    fullWidth
                    label={
                      <span style={{ fontFamily: "var(--font-outfit)" }}>
                        {t("foundingMemberMain.businessEmail")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="businessEmail"
                    type="email"
                    value={formData.businessEmail}
                    onChange={handleChange}
                    required
                    disabled={isSubmitting || emailVerifying}
                    error={!!errors.businessEmail}
                    helperText={errors.businessEmail}
                    FormHelperTextProps={{
                      sx: {
                        position: "absolute",
                        bottom: "-20px",
                        margin: 0,
                        fontSize: "12px",
                      },
                    }}
                    sx={textFieldSx()}
                  />
                  <TextField
                    fullWidth
                    label={
                      <span style={{ fontFamily: "var(--font-outfit)" }}>
                        {t("foundingMemberMain.phoneNumber")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleChange}
                    required
                    disabled={isSubmitting || emailVerifying}
                    error={!!errors.phoneNumber}
                    helperText={errors.phoneNumber}
                    FormHelperTextProps={{
                      sx: {
                        position: "absolute",
                        bottom: "-20px",
                        margin: 0,
                        fontSize: "12px",
                      },
                    }}
                    sx={textFieldSx()}
                  />
                  <TextField
                    fullWidth
                    label={t("foundingMemberMain.linkedinProfile")}
                    name="linkedinProfile"
                    value={formData.linkedinProfile}
                    onChange={handleChange}
                    disabled={isSubmitting || emailVerifying}
                    error={!!errors.linkedinProfile}
                    helperText={errors.linkedinProfile}
                    FormHelperTextProps={{
                      sx: {
                        position: "absolute",
                        bottom: "-20px",
                        margin: 0,
                        fontSize: "12px",
                      },
                    }}
                    sx={textFieldSx({ mb: 2 })}
                  />

                  {/* reCAPTCHA v3 is invisible — no checkbox/widget is rendered.
                      Google requires disclosing that the site is protected by
                      reCAPTCHA when the badge itself isn't shown. */}
                  <Typography
                    sx={{
                      fontFamily: "var(--font-outfit)",
                      fontSize: "0.7rem",
                      color: "#9CA3AF",
                      mb: 2,
                      textAlign: isArabic ? "right" : "left",
                      mt: 1,
                    }}
                  >
                    {t("bookDemoSection.form.recaptchaDisclosure", {
                      defaultValue:
                        "This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.",
                    })}
                  </Typography>
                  {captchaError && (
                    <Typography
                      sx={{
                        color: "#d32f2f",
                        fontSize: "12px",
                        mb: 2,
                        textAlign: isArabic ? "right" : "left",
                      }}
                    >
                      {captchaError}
                    </Typography>
                  )}

                  {/* Verifying email message (Reoon Power Mode check) */}
                  {emailVerifying && (
                    <Box
                      sx={{
                        display: "flex",
                        // alignItems: "center",
                        // justifyContent: "center",
                        gap: 1,
                        mb: 2,
                      }}
                    >
                      <CircularProgress size={14} sx={{ color: "#7c3aed" }} />
                      <Typography
                        sx={{
                          fontFamily: "var(--font-outfit)",
                          fontSize: "0.8rem",
                          color: "#6B7280",
                          textAlign: isArabic ? "right" : "left",
                        }}
                      >
                        {t("foundingMemberMain.verifyingEmail")}
                      </Typography>
                    </Box>
                  )}

                  <Button
                    fullWidth
                    type="submit"
                    variant="contained"
                    disabled={isSubmitting || emailVerifying}
                    sx={{
                      fontFamily: "var(--font-outfit)",
                      bgcolor: "#7c3aed",
                      color: "#fff",
                      py: { xs: 1.5, sm: 1.8 },
                      fontSize: { xs: "14px", sm: "16px", md: "18px" },
                      fontWeight: "600",
                      textTransform: "none",
                      borderRadius: 2.5,
                      boxShadow: "none",
                      "&:hover": { bgcolor: "#7c3aed", boxShadow: "none" },
                      "&:disabled": { bgcolor: "#9ca3af", color: "#fff" },
                    }}
                    endIcon={
                      <ArrowForwardIcon
                        sx={{
                          fontSize: { xs: "18px", sm: "22px" },
                          transform: isArabic ? "scaleX(-1)" : "none",
                          mt: isArabic ? "30%" : 0,
                          mr: isArabic ? "30%" : 0,
                        }}
                      />
                    }
                  >
                    {isSubmitting || emailVerifying
                      ? t("foundingMemberMain.submitting")
                      : t("foundingMemberMain.submitBtn")}
                  </Button>

                  <Box
                    sx={{ display: "flex", justifyContent: "center", mt: 2.5 }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        flexDirection: "row",
                        gap: 1,
                        maxWidth: { xs: "100%", sm: "600px" },
                        flexWrap: "nowrap",
                      }}
                    >
                      <Box sx={{ flexShrink: 0, mt: 0.2 }}>
                        <LockIcon style={{ fontSize: 20, color: "#6B7280" }} />
                      </Box>
                      <Typography
                        sx={{
                          color: "#6B7280",
                          lineHeight: 1.5,
                          fontSize: { xs: "13px", sm: "15px", md: "16px" },
                          fontFamily: "var(--font-outfit)",
                          fontWeight: 400,
                          textAlign: isArabic ? "right" : "center",
                        }}
                      >
                        {t("foundingMemberMain.formNote")}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </GoogleCaptchaWrapper>
  );
};

export default FoundingMemberMainSection;